import React, { useState, useEffect } from "react";
import NavBar from "./Components/NavBar";
import ItemUsuario from "./Components/ItemUsuario";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, Link } from "react-router-dom";
import {
  collection,
  getDocs,
  doc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import Box from "@mui/material/Box";
import axios from "axios";

import TextField from "@mui/material/TextField";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { db } from "./FirebaseConfig/firebase";
import IconButton from "@mui/material/IconButton";
import ArrowCircleRightRoundedIcon from "@mui/icons-material/ArrowCircleRightRounded";
import "./CSS/usuarios.css";

const MySwal = withReactContent(Swal);

function Usuarios() {
  const navigate = useNavigate();
  const [dniUsuario, setDniUsuario] = useState("");
  const [nombre, setNombre] = useState("");
  const [nombresList, setNombresList] = useState([]);
  const [listFilter, setListFilter] = useState([]);

  //referenciar la DB
  const nList = collection(db, "USUARIOS");
  //funcion para mostrar la lista de comunicados
  const getUsuarios = async () => {
    const data = await getDocs(nList);
    setNombresList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    console.log("asdasd" + nombresList);
  };
  function esNumero(value) {
    console.log("23123" + value);

    if (value) {
      if (!isNaN(value)) {
        console.log("es nsdumero");
        setListFilter(
          nombresList.filter((userItem) => String(userItem.dni).includes(value))
        );
        console.log(listFilter);
      } else {
        console.log("es nombre");

        setListFilter(
          nombresList.filter((userItem) =>
            String(userItem.nombre).toUpperCase().includes(value)
          )
        );
      }
    } else {
      setListFilter([]);
    }
  }
  //funcion para buscar usuarios por dni
  async function getUserByDni() {
    console.log("el clicl es " + dniUsuario);
    let fl = 0;
    const q = query(collection(db, "USUARIOS"), where("dni", "==", dniUsuario));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      fl = 1;
      console.log("INGRESO", doc.data());
      setNombre(doc.data().nombre);
    });
    if (fl == 0) {
      console.log("Usuario no encontrado");
    }
  }
  //Funcion para eliminar usuarios
  const deleteUsuario = async (id) => {
    MySwal.fire({
      title: "Eliminar usuario?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar! ",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const usuario = doc(db, "USUARIOS", id);
        await deleteDoc(usuario);
        setListFilter([]);
        getUsuarios();

        Swal.fire("Eliminado!", "El usuario ha sido eliminado", "success");
      }
    });
  };
  const buscarUsuario = async (value) => {
    console.log("el valor es: " + value);

    if (value) {
      if (!isNaN(value)) {
        if (value.length == 8) {
          console.log("Buscar por DNI");
          const res = await axios.get(
            `https://reservas.ciparequipa.org.pe/buscarIngeniero/${value}`
          );
          if (res.data.length != 0) {
            setListFilter(res.data);
            console.log(res.data);
          } else {
            Swal.fire("Usuario no encontrado", "", "error");
            setListFilter([]);
          }
        }
        if (value.length <= 6) {
          console.log("Buscar por CIP");
          const res = await axios.get(
            `https://reservas.ciparequipa.org.pe/colegiados/${value}`
          );
          if (res.data.length != 0) {
            setListFilter(res.data);
          } else {
            Swal.fire("Usuario no encontrado", "", "error");
            setListFilter([]);
          }
        }
      } else {
        console.log("es letra");
        const res = await axios.get(
          `https://reservas.ciparequipa.org.pe/buscarByName/${value}`
        );
        if (res.data.length != 0) {
          setListFilter(res.data);
        } else {
          Swal.fire("Usuario no encontrado", "", "error");
          setListFilter([]);
        }
      }
    } else {
      Swal.fire("Datos incorrectos", "", "error");
      //setListFilter([]);
    }
  };
  const handleOnChange = (event) => {
    setDniUsuario(event.target.value);
    //esNumero(event.target.value);
  };
  //cerrar cupones
  const cerrar = () => {
    if (localStorage.getItem("nombreLocal") == "CIP") {
      navigate("../panelCDA");
    } else {
      navigate("../panelAdmin");
    }
  };
  //uso de useEffect
  useEffect(() => {
    //getUsuarios();
  }, []);

  return (
    <div className="usuarios">
      <NavBar
        titulo="Usuarios"
        imagen="cerrar"
        logoTitulo="usuarios"
        cerrar={cerrar}
      ></NavBar>

      <div className="usuarios-buscador">
        <Box sx={{ width: 250 }}>
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <PersonSearchIcon sx={{ color: "action.active", mr: 1, my: 0.5 }} />
            <TextField
              sx={{ width: 350 }}
              label="Nombres, DNI o CIP"
              variant="standard"
              value={dniUsuario}
              onChange={handleOnChange}
            />
          </Box>
        </Box>
        <div className="fau-addUser">
          <input
            type="submit"
            value="  Buscar  "
            className="btn-agregar"
            onClick={() => {
              buscarUsuario(dniUsuario);
            }}
          />
        </div>
      </div>

      <div className="usuarios-item">
        {listFilter.map((item) => (
          <div className="usuarios-element" key={item.id}>
            <ItemUsuario
              nombre={item.vapecol + " " + item.vnomcol}
              dni={item.ndnicol}
              cip={item.ncodcol}
              id={item.id}
              sexo={item.sexo}
              estado={item.nestcol == 1 ? "HABILITADO" : "NO HABILITADO"}
              deleteUsuario={deleteUsuario}
            />
          </div>
        ))}
      </div>
    
    </div>
  );
}

export default Usuarios;
